import BeaconList from "./BeaconList";

export default BeaconList